export default __webpack_public_path__ + "static/media/standard.87423597.png";